import { Component, OnInit } from '@angular/core';

import { FieldType } from '@ngx-formly/core';

import { ApiService } from '@services';

import { TaFormlyFieldConfig } from '../ta-formly-types';

import { Asset } from '@models';

const TAG = 'TaAssetSelectComponent ';

@Component({
    selector: 'app-ta-asset-select',
    templateUrl: './ta-asset-select.component.html',
    styleUrls: ['./ta-asset-select.component.scss']
})
export class TaAssetSelectComponent extends FieldType<TaFormlyFieldConfig> implements OnInit {

    public assets: Asset[] = [];
    public isLoading = true;

    constructor(
        private apiService: ApiService
    ) {
        super();
    }

    ngOnInit() {
        this.getAssets();
    }

    private async getAssets() {
        this.isLoading = true;
        try {
            const data = await this.apiService.queryAssets('active', 'asset', this.props.clientId, this.props.assetFormConfigId);
            if (data && data.length > 0) {
                this.formControl.setValue(data[0].identifiers.asset_identifier);
                this.assets = data;
            }
        } catch (error) {
            console.log(TAG + 'getAssets: error=', error);
        }
        this.isLoading = false;
    }
}
